<template>
    <v-container grid-list>
        <!-- Chat -->
        <v-card max-width="900px" style="margin: 0; margin-bottom: -1vh">
            <v-card-title
                :class="small ? 'static-position' : ''"
                style="padding: 10px; position: static"
            >
                <v-row justify="space-between" :align="small ? 'start' : 'center'" no-gutters>
                    <v-col :cols="$vuetify.display.mobile && !small ? 12 : 'auto'">
                        <h5 v-if="small" class="px-2 py-3">{{ chatTitle }}</h5>
                        <h1 v-else class="px-2 py-3">{{ chatTitle }}</h1>
                    </v-col>
                    <v-spacer />
                    <v-col :cols="$vuetify.display.mobile && !small ? 12 : 'auto'">
                        <v-switch
                            v-model="starredOnly"
                            :label="` ${small ? 'Important' : 'Messages importants'}`"
                            class="pa-2"
                            :class="$vuetify.display.mobile && !small ? '' : 'text-right'"
                            :dense="small"
                        />
                    </v-col>
                </v-row>
                <v-divider />
            </v-card-title>
            <v-card-text
                id="chatMessages"
                ref="chatMessages"
                :style="{ padding: 0, overflowY: 'auto', height: height }"
                v-if="showDiscussion"
            >
                <ChatConversation
                    :chatType="chatType"
                    :messages="messages"
                    :starredOnly="starredOnly"
                />
            </v-card-text>
            <v-divider v-if="showDiscussion && !starredOnly" />
            <!-- <v-card-actions style="position: static" v-if="showDiscussion && !starredOnly"> -->

            <v-text-field-filled
                class="mx-2 pt-2 mb-2"
                v-model="messageToSend"
                @keyup.enter="send()"
                append-inner-icon="$send"
                placeholder="Saisir votre message..."
                v-if="showDiscussion && !starredOnly"
                @click:append-inner="send()"
            />
            <!-- </v-card-actions> -->
        </v-card>
    </v-container>
</template>

<script lang="ts">
import { ChatBase } from "./ChatBase";
import ChatConversation from "./ChatConversation.vue";
import { Component, toNative, Prop } from "vue-facing-decorator";

@Component({
    components: {
        ChatConversation,
    },
})
export class ChatCompany extends ChatBase {
    @Prop({ default: false }) small: Boolean; // Reduces fonts and UI view
    @Prop({ default: "75vh" }) height: number | string;
    get chatType(): string {
        return "COMPANY";
    }

    starredOnly = false; // Show only important messages
}

export default toNative(ChatCompany);
</script>

<style lang="scss" scoped>
.static-position {
    position: static !important;
}

.absolute-position {
    position: absolute !important;
}
</style>
